import React, { useState } from 'react';
import { staffApi } from '../lib/api';
import { Button } from './ui/button';
import { Input } from './ui/input';
import { Label } from './ui/label';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter, DialogDescription } from './ui/dialog';
import { toast } from 'sonner';

// Dialog condiviso crea/rinomina cartella documenti staff.
// Usato sia nel tab Documenti del dipendente (StaffMemberPage) sia nel
// tab "Cartelle documenti" di Gestione Staff (StaffFoldersManager).
export const FolderDialog = ({ mode, folder, parent, onClose, onSaved }) => {
  const [name, setName] = useState(mode === 'rename' ? folder?.name || '' : '');
  const [saving, setSaving] = useState(false);

  async function submit() {
    const cleaned = name.trim();
    if (!cleaned) { toast.error('Nome cartella obbligatorio'); return; }
    setSaving(true);
    try {
      if (mode === 'rename') {
        await staffApi.renameFolder(folder.folder_id, { name: cleaned });
        toast.success('Cartella rinominata');
      } else {
        await staffApi.createFolder({ name: cleaned, parent_folder_id: parent?.folder_id || null });
        toast.success('Cartella creata');
      }
      onSaved();
    } catch (e) {
      toast.error(e?.response?.data?.detail || 'Errore salvataggio cartella');
    } finally { setSaving(false); }
  }

  return (
    <Dialog open onOpenChange={(o) => { if (!o) onClose(); }}>
      <DialogContent className="max-w-md" data-testid="folder-dialog">
        <DialogHeader>
          <DialogTitle>{mode === 'rename' ? 'Rinomina cartella' : 'Nuova cartella'}</DialogTitle>
          <DialogDescription>
            {mode === 'rename'
              ? 'Cambia il nome della cartella. Tutte le sotto-cartelle si aggiornano automaticamente.'
              : (parent
                ? <>Nuova sotto-cartella dentro <b>{parent.path}</b>.</>
                : 'Nuova cartella di primo livello.')}
          </DialogDescription>
        </DialogHeader>
        <div className="py-2">
          <Label className="text-xs uppercase tracking-wide">Nome *</Label>
          <Input
            value={name}
            onChange={(e) => setName(e.target.value)}
            placeholder="Es. Buste paga"
            autoFocus
            data-testid="folder-name-input"
            onKeyDown={(e) => { if (e.key === 'Enter') submit(); }}
          />
          <p className="text-[11px] text-slate-500 mt-1">Senza '/' o '\\'. Max 100 caratteri.</p>
        </div>
        <DialogFooter>
          <Button variant="outline" onClick={onClose} disabled={saving}>Annulla</Button>
          <Button onClick={submit} disabled={saving || !name.trim()} data-testid="folder-save">
            {saving ? 'Salvataggio…' : (mode === 'rename' ? 'Rinomina' : 'Crea')}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
